import React, { useState } from "react";
import "../components/Student/StuStyles/StuLiveRegister.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ApiService from "../nhrc_apis/ApiService";

const { UserAPI } = ApiService;

const Hreventregister = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const eventData = state?.event;

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName:         "",
    mobile:           "",
    email:            "",
    location:         "",
    iama:             "",
    nhrcId:           "",
    organisation:     "",   // maps to company_name
    companylocation:  "",   // maps to company_location
    yearofpassout:    "",
    updates:          false,
  });

  const [errors, setErrors]   = useState({});
  const [touched, setTouched] = useState({});

  // ─── VALIDATE SINGLE FIELD ────────────────────────────────
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "fullName":
        if (!value || !value.trim()) {
          error = "Full name is required.";
        } else if (value.trim().length < 3) {
          error = "Full name must be at least 3 characters.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Full name must contain only letters and spaces.";
        }
        break;

      case "mobile":
        if (!value || !value.trim()) {
          error = "Mobile number is required.";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Mobile number must be exactly 10 digits.";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "location":
        if (!value || !value.trim()) {
          error = "Location is required.";
        } else if (value.trim().length < 2) {
          error = "Location must be at least 2 characters.";
        }
        break;

      case "iama":
        if (!value || !value.trim()) {
          error = "This field is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "This field must contain only letters and spaces.";
        }
        break;

      case "nhrcId":
        if (!value || !value.trim()) {
          error = "NHRC ID is required.";
        } else if (value.trim().length < 3) {
          error = "NHRC ID must be at least 3 characters.";
        }
        break;

      case "organisation":
        if (!value || !value.trim()) {
          error = "Organisation name is required.";
        } else if (value.trim().length < 3) {
          error = "Organisation name must be at least 3 characters.";
        }
        break;

      case "yearofpassout":
        if (!value || !value.trim()) {
          error = "Year of pass out is required.";
        } else if (!/^[0-9]{4}$/.test(value.trim())) {
          error = "Enter a valid 4-digit year (e.g. 2025).";
        } else if (
          parseInt(value.trim()) < 1980 ||
          parseInt(value.trim()) > 2035
        ) {
          error = "Year must be between 1980 and 2035.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE ALL FIELDS ──────────────────────────────────
  const validateAll = () => {
    const fields = [
      "fullName", "mobile", "email", "location",
      "iama", "nhrcId", "organisation", "yearofpassout",
    ];

    const newErrors  = {};
    const newTouched = {};

    fields.forEach((field) => {
      newTouched[field] = true;
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    setTouched(newTouched);
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ─── HANDLE CHANGE ────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData({ ...formData, [name]: newValue });

    if (name !== "updates") {
      const error = validateField(name, newValue);
      setErrors((prev)  => ({ ...prev, [name]: error }));
      setTouched((prev) => ({ ...prev, [name]: true  }));
    }
  };

  // ─── HANDLE RESET ─────────────────────────────────────────
  const handleReset = () => {
    setFormData({
      fullName:         "",
      mobile:           "",
      email:            "",
      location:         "",
      iama:             "",
      nhrcId:           "",
      organisation:     "",
      companylocation:  "",
      yearofpassout:    "",
      updates:          false,
    });
    setErrors({});
    setTouched({});
  };

  // ─── HANDLE SUBMIT ────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isValid = validateAll();

    if (!isValid) {
      toast.error("Please fill all required fields correctly.", { autoClose: 2000 });
      return;
    }

    try {
      setLoading(true);

      // ✅ payload keys match backend RegistrationCreate schema exactly
      // ✅ This is an EVENT registration → send event_id only, job_fair_id stays null
      const payload = {
        event_id:          eventData?.id || null,
        job_fair_id:       null,
        full_name:         formData.fullName.trim(),
        phone:             formData.mobile.trim(),
        location:          formData.location.trim(),
        iam_a:             formData.iama.trim(),
        nhrc_id:           formData.nhrcId.trim(),
        college_name:      formData.organisation.trim(),
        year_of_passout:   formData.yearofpassout.trim(),
        receive_updates:   formData.updates,
        company_name:      formData.organisation.trim(),
        company_location:  formData.companylocation.trim(),
      };

      console.log("HR EVENT REGISTER PAYLOAD:", payload);

      const response = await UserAPI.registerUser(payload);

      console.log("HR EVENT REGISTER SUCCESS:", response.data);

      toast.success("Registered Successfully!", { autoClose: 2000 });

      setTimeout(() => {
        navigate("/hrdashboard/Hrliveevents");
      }, 2000);

    } catch (error) {
      console.error("HR EVENT REGISTER ERROR:", error?.response?.data || error?.message);
      console.error(
        "FULL VALIDATION DETAIL:",
        JSON.stringify(error?.response?.data?.detail, null, 2)
      );

      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;

      // No response reached the client at all (server down/asleep/CORS/offline)
      if (!error?.response) {
        toast.error(
          "Network error — server may be waking up or unreachable. Please wait a moment and try again.",
          { autoClose: 4000 }
        );

      } else if (status === 422 && Array.isArray(detail)) {
        detail.forEach((d, i) => {
          console.error(
            `VALIDATION ERROR #${i + 1} → field: ${d?.loc?.join(".")}, msg: ${d?.msg}`
          );
        });

        const firstError = detail[0];
        const field = firstError?.loc?.[1] || "field";
        const msg   = firstError?.msg       || "Validation error";
        toast.error(`Validation error — ${field}: ${msg}`, { autoClose: 3500 });

      } else if (status === 400 && typeof detail === "string") {
        toast.error(detail, { autoClose: 3000 });

      } else if (status === 401) {
        toast.error("Session expired. Please login again.", { autoClose: 2500 });
        setTimeout(() => navigate("/login"), 2600);

      } else if (status === 409) {
        toast.error("You have already registered for this event!", { autoClose: 2500 });

      } else if (typeof detail === "string") {
        toast.error(detail, { autoClose: 2500 });

      } else {
        toast.error(
          error?.response?.data?.message || "Registration Failed. Please try again.",
          { autoClose: 2500 }
        );
      }

    } finally {
      setLoading(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────────
  return (
    <>
      <div className="stu-live-pg-register-wrapper">
        <form
          className="stu-live-pg-register-card"
          onSubmit={handleSubmit}
          noValidate
        >

          {eventData && (
            <div className="justfity-content-center">
              <h3 className="stu-live-pg-register-selected">
                <span>{eventData.eventTitle || eventData.title}</span>
              </h3>
              <h5 className="stu-live-pg-register-selected-date">
                <span>{eventData.schedule}</span>
              </h5>
            </div>
          )}

          <h2 className="stu-live-pg-register-title">REGISTER FORM</h2>

          <div className="stu-live-pg-register-grid">

            {/* Full Name */}
            <div className="stu-live-pg-register-field">
              <label>Full Name*</label>
              <input
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                className={errors.fullName ? "input-error" : ""}
              />
              {errors.fullName && <span className="error-text">{errors.fullName}</span>}
            </div>

            {/* Mobile Number */}
            <div className="stu-live-pg-register-field">
              <label>Mobile Number*</label>
              <input
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
                className={errors.mobile ? "input-error" : ""}
              />
              {errors.mobile && <span className="error-text">{errors.mobile}</span>}
            </div>

            {/* Email */}
            <div className="stu-live-pg-register-field">
              <label>Email Id*</label>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            {/* Location */}
            <div className="stu-live-pg-register-field">
              <label>Location*</label>
              <input
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter your location"
                className={errors.location ? "input-error" : ""}
              />
              {errors.location && <span className="error-text">{errors.location}</span>}
            </div>

            {/* I am a */}
            <div className="stu-live-pg-register-field stu-live-pg-register-pincode">
              <label>Iam a*</label>
              <input
                name="iama"
                value={formData.iama}
                onChange={handleChange}
                placeholder="e.g. HR, Employee, Professional"
                className={errors.iama ? "input-error" : ""}
              />
              {errors.iama && <span className="error-text">{errors.iama}</span>}
            </div>

            {/* NHRC ID */}
            <div className="stu-live-pg-register-field">
              <label>NHRC ID*</label>
              <input
                name="nhrcId"
                value={formData.nhrcId}
                onChange={handleChange}
                placeholder="Enter your NHRC ID"
                className={errors.nhrcId ? "input-error" : ""}
              />
              {errors.nhrcId && <span className="error-text">{errors.nhrcId}</span>}
            </div>

            {/* Organisation Name — maps to company_name in payload */}
            <div className="stu-live-pg-register-field">
              <label>Organisation Name*</label>
              <input
                name="organisation"
                value={formData.organisation}
                onChange={handleChange}
                placeholder="Enter your organisation name"
                className={errors.organisation ? "input-error" : ""}
              />
              {errors.organisation && <span className="error-text">{errors.organisation}</span>}
            </div>

            {/* Company Location — optional, from Swagger */}
            <div className="stu-live-pg-register-field">
              <label>Company Location (Optional)</label>
              <input
                name="companylocation"
                value={formData.companylocation}
                onChange={handleChange}
                placeholder="Enter your company location"
              />
            </div>

            {/* Year of Passout */}
            <div className="stu-live-pg-register-field">
              <label>Year of Passout*</label>
              <input
                name="yearofpassout"
                value={formData.yearofpassout}
                onChange={handleChange}
                placeholder="e.g. 2025"
                maxLength={4}
                className={errors.yearofpassout ? "input-error" : ""}
              />
              {errors.yearofpassout && <span className="error-text">{errors.yearofpassout}</span>}
            </div>

          </div>

          {/* Checkbox */}
          <div className="stu-live-pg-register-checkbox">
            <p>Would you like to receive updates about future events and professional opportunities? *</p>
            <input
              type="checkbox"
              name="updates"
              onChange={handleChange}
              checked={formData.updates}
              className="check-lve"
            />
          </div>

          {/* Buttons */}
          <div className="stu-live-pg-register-buttons">
            <button
              type="button"
              className="stu-live-pg-register-reset"
              onClick={handleReset}
              disabled={loading}
            >
              Clear
            </button>
            <button
              type="submit"
              className="stu-live-pg-register-submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "SUBMIT"}
            </button>
          </div>

        </form>
      </div>

      <ToastContainer position="top-center" />
    </>
  );
};

export default Hreventregister;